import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ContactState from './Contact.types';

const initialState: ContactState = {
  type: 'person',
  modalActive: false,
  loading: '',
};

export const contactReducer = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    setContact: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    },
    setContactModalActive: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        modalActive: payload,
      };
    },
    setLoading: (state, action: PayloadAction<string>) => {
      const { payload } = action;
      return {
        ...state,
        loading: payload,
      };
    },
  },
});

export const { setContact, setContactModalActive, setLoading } = contactReducer.actions;

export default contactReducer.reducer;
